module.exports = __webpack_public_path__ + "static/media/cloud.206a1e79.svg";